<template>

    <div class="col-md-6 col-sm-12 mb-sm-4 profile-block profile-block-premium" v-if="userProp"
         :class="{'profile-block-premium-venue':userProp.is_venue}"
         :key="`premium-${userProp.id}-${firstPhotoIsExplicit}-${secondPhotoIsExplicit}`"
    >
        <span class="profile-block-images-top-badge-container" v-if="userProp.goldBoostActive">
            <div class="small-banner-gold-boost">
                <icon-component :icon="fa_crown()"/>
                <span>TOP</span>
            </div>
        </span>

        <a :href="regionRelativeUrl(userProp.profile_path)" @click.prevent="$emit('onUserClick', userProp)"
           class="profile-block-link"
           :class="{'profile-block-link--venue': userProp.is_venue && !userProp.photos_data}">

                <span
                    class="profile-block-images-top-icons-container profile-block-images-top-icons-container--premium pl-3 pt-2"
                    v-if="userProp.private_gallery_photos_count || userProp.total_videos_count"
                    :class="{'has-boosted-gold': userProp.goldBoostActive}">
                    <icon-component v-if="userProp.private_gallery_photos_count" class="fa-icon"
                                    :icon="fa_gem()"></icon-component>
                    <icon-component v-if="userProp.total_videos_count" class="fa-icon"
                                    :icon="fa_video_play()"></icon-component>
                </span>

            <span class="profile-block-images">

                    <explicit-photo-placeholder v-if="firstPhotoIsExplicit"
                                                :key="`first-explicit-${userProp.id}-${firstPhotoIsExplicit}`"
                                                class="explicit-photo-placeholder-first"
                                                e2e-id="search-photo-first-explicit"
                                                verificationOrigin="search"
                                                :profileUserId="userProp.id"
                                                :class="{'explicit-photo-placeholder--venue': userProp.is_venue}"
                    ></explicit-photo-placeholder>

                    <picture class="lozad lazyload-img" v-else e2e-id="search-photo-first"
                             :class="{'profile-block-images--venue': userProp.is_venue}"
                             :data-iesrc="getPhotoUrl(userProp,'jpg',userProp.is_venue ? 'l-medium'  :'medium')">
                        <source :srcset="getPhotoSrcSet(userProp,'webp', 0, userProp.is_venue ? 'l-medium'  :'medium')"
                                class="lazyload-src" type="image/webp">
                        <source :srcset="getPhotoSrcSet(userProp,'jpg', 0, userProp.is_venue ? 'l-medium'  :'medium')"
                                class="lazyload-src" type="image/jpeg">

                        <!-- SEO: keep src="" EMPTY. Real src here (commit 528f2648) exposed ~30 photos/page to Googlebot-Image and killed SERP SEO — see CLAUDE.md "SEO Hard Rules". -->
                        <noscript>
                            <img src="" class="lazyload-img lazyload-noscript" :style="'  background: url(' +
                                 getPhotoUrl(userProp,'jpg',userProp.is_venue ? 'l-medium'  :'medium') +') no-repeat; background-size:cover;'"
                                 alt="">
                        </noscript>

                        <div class="profile-block-images-top-vip-tag"
                             v-if="getPhotoObject(userProp) && getPhotoObject(userProp).explicit && !firstPhotoIsExplicit">
                            <img src="/images/viptag.png" alt="">
                        </div>

                    </picture>


                    <img class="ml-auto"
                         v-if="(!userProp.photos_data || userProp.photos_data.length < 2) && !userProp.is_venue"
                         :src="noPhotoUrl" alt=""/>

                    <template v-if="!userProp.is_venue && userProp.photos_data && userProp.photos_data.length > 1">
                        <explicit-photo-placeholder v-if="secondPhotoIsExplicit"
                                                    :show-action-buttons="false"
                                                    :key="`second-explicit-${userProp.id}-${secondPhotoIsExplicit}`"
                                                    :class="{'explicit-photo-placeholder-last': !firstPhotoIsExplicit}"
                                                    e2e-id="search-photo-second-explicit"
                                                    verificationOrigin="search"
                                                    :profileUserId="userProp.id">
                        ></explicit-photo-placeholder>
                        <picture v-else e2e-id="search-photo-second"
                                 class="lozad lazyload-img ml-auto"
                                 :data-iesrc="getPhotoUrl(userProp,'jpg','medium',1)">

                            <source :srcset="getPhotoSrcSet(userProp,'webp',1)"
                                    class="lazyload-src" type="image/webp">
                            <source :srcset="getPhotoSrcSet(userProp,'jpg',1)"
                                    class="lazyload-src" type="image/jpeg">

                            <!-- SEO: keep src="" EMPTY. Real src here (commit 528f2648) exposed ~30 photos/page to Googlebot-Image and killed SERP SEO — see CLAUDE.md "SEO Hard Rules". -->
                            <noscript>
                                <img src="" class="lazyload-img ml-auto" :style="'  background: url(' +
                                     getPhotoUrl(userProp,'jpg','medium',1) +') no-repeat; background-size:cover;'"
                                     alt="">
                            </noscript>

                            <div class="profile-block-images-top-vip-tag"
                                 v-if="getPhotoObject(userProp, 1) && getPhotoObject(userProp, 1).explicit && !secondPhotoIsExplicit">
                                <img src="/images/viptag.png" alt="">
                            </div>

                        </picture>
                    </template>

                </span>

        </a>

        <span class="profile-block-images-badge-container">
            <span class="profile-block-images-badge-container-right-wrapper">
                <span class="small-banner gold" :class="{'premium--boost': userProp.goldBoostActive}">
                    <template v-if="userProp.goldBoostActive">
                        Gold VIP <icon-component :icon="magicWand()" width="14px" height="14px"></icon-component>
                    </template>
                    <template v-if="!userProp.goldBoostActive">
                        Gold <icon-component :icon="magicWand()" width="14px" height="14px"></icon-component>
                    </template>
                </span>

                <span v-if="userProp.isOnline" class="small-banner online">
                    {{ translate.home.onlineNow }}
                </span>
                <span v-else-if="showAvailable" class="small-banner available">
                    <icon-component :icon="fa_calendar()"></icon-component>
                    {{ translate.account.availableToday }}
                </span>
            </span>
        </span>

        <span class="profile-block-details" :class="{'profile-block-details--bigger-margin':firstPhotoIsExplicit}">

            <span class="user-details user-details--premium">
                <span class="heading-1 d-flex">
                    <span class="text-ellipsis" e2e-id="search-profile-username">{{ userProp.username }}</span>
                    <span class="flex-shrink-0 flex-grow-0">{{ getUserAge(userProp, ', ') }}</span>
                    <span class="mx-2 color-red-base" v-if="userProp.score !== undefined">{{
                            ` SCORE: ${userProp.score}`
                        }}</span>

                    <span class="small-banner verified-v2 small" v-if="showVerified">
                        <icon-component :icon="checkBadge()" />
                        <span>{{ translate.account.verified }}</span>
                    </span>
                    <span class="small-banner new small" v-if="isNewUser(userProp)">
                        <icon-component :icon="fa_clock()" />
                        <span>{{ translate.home.new }}</span>
                    </span>
                    <span class="small-banner agency small" v-if="!userProp.is_venue && userProp.isIndependent === false">
                        <icon-component :icon="agencyIcon()" />
                        <span>{{ translate.account.agency }}</span>
                    </span>
                </span>
                <span class="user-details-location d-flex overflow-hidden" v-if="!userProp.found_by_outcall_location">
                    <span class="text-ellipsis">{{ getUserLocationForSearch(userProp) }}</span>

                    <span class="distance">
                        <template v-if="userProp.distance >=0">
                            {{ userProp.distance + 'km' }}
                        </template>
                        <template v-else>
                            <a href="#" @click.prevent="onDistanceClick(userProp)">{{
                                translate.home.distance
                            }}</a>
                        </template>
                    </span>
                </span>
                <span class="user-details-location d-flex overflow-hidden user-details-location--outcall"
                      v-if="userProp.outcall_distance"
                      v-html="outCallDistanceHTML"></span>
            </span>

        </span>

    </div>

</template>

<script>

import userMixin from "@/components/mixins/userMixin";
import photoMixin from "@/components/mixins/photoMixin";
import ExplicitPhotoPlaceholderComponent from "@/components/partials/ExplicitPhotoPlaceholderComponent";
import PrivateGallerySearchIconComponent
    from "@/components/search/partials/icons/PrivateGallerySearchIconComponent.vue";
import translateMixin from "@/components/mixins/translateMixin";
import {isEscortAvailableToday} from "@/core/utils/helpers/users/escort/escortHelpers";
import escortViewMixin from "@/components/mixins/search/escortViewMixin";
import {
    agencyIcon,
    checkBadge,
    fa_calendar,
    fa_clock, fa_crown,
    fa_gem,
    fa_users,
    fa_video,
    fa_video_play,
    magicWand,
} from "@/core/constants/icons";
import IconComponent from "@/components/global/IconComponent.vue";
import regionsUrlMixin from "@/components/mixins/regions/regionsUrlMixin";
import {RegionalExplicitEnum} from "@/core/constants/enums/regionalExplicitEnum";

const data = () => {
    return {
        noPhotoUrl: constants.user_photo.NO_PHOTO_SEARCH_URL,
        maxCityLength: 16,
    }
}

function onDistanceClick() {
    this.$emit('onDistanceClick');
}

function photoIsExplicit(photo) {
    if (_.isEqual(_.get(this, 'currentUser.allowed_explicit_photo'), this.userProp.id)) {
        return false;
    }

    return _.get(photo, 'explicit') && (!this.isAgeVerified || !this.isVipPunter);
}

export default {
    data,
    computed: {
        ...mapState(['translate', 'userIsFromExplicitRegion']),
        firstPhotoIsExplicit() {
            if (_.isEqual(_.get(this, 'currentUser.allowed_explicit_photo'), this.userProp.id)) {
                return false;
            }

            if (this.isAgeVerified || this.isVipPunter) {
                return false;
            }

            const firstRegionalExplicit = _.get(this, 'userProp.photos_data.0.regionalExplicit');
            if ((firstRegionalExplicit === RegionalExplicitEnum.YES || firstRegionalExplicit === RegionalExplicitEnum.ERROR) && this.userIsFromExplicitRegion) {
                return true;
            }

            return !!_.get(this, 'userProp.photos_data.0.explicit');
        },
        secondPhotoIsExplicit() {
            if (_.isEqual(_.get(this, 'currentUser.allowed_explicit_photo'), this.userProp.id)) {
                return false;
            }

            if (this.isAgeVerified || this.isVipPunter) {
                return false;
            }

            const secondRegionalExplicit = _.get(this, 'userProp.photos_data.1.regionalExplicit');
            if ((secondRegionalExplicit === RegionalExplicitEnum.YES || secondRegionalExplicit === RegionalExplicitEnum.ERROR) && this.userIsFromExplicitRegion) {
                return true;
            }

            return !!_.get(this, 'userProp.photos_data.1.explicit');
        },
        showVerified() {
            return !this.firstPhotoIsExplicit && _.get(this, 'userProp.verification_status') === 1
        },
        showAvailable() {
            return isEscortAvailableToday(this.userProp);
        },
    },
    props: ['userProp'],
    mixins: [
        userMixin,
        photoMixin,
        translateMixin,
        escortViewMixin,
        regionsUrlMixin,
    ],
    components: {
        IconComponent,
        'explicit-photo-placeholder': ExplicitPhotoPlaceholderComponent,
        'private-gallery-search-icon': PrivateGallerySearchIconComponent,
    },
    methods: {
        agencyIcon,
        fa_crown,
        magicWand,
        fa_gem,
        fa_video_play,
        fa_clock,
        fa_users,
        checkBadge,
        fa_calendar,
        fa_video,
        onDistanceClick,
        photoIsExplicit,
    },
}
</script>
